import { compose } from 'redux';
import { connect } from 'react-redux';
import selectors from '../../../../rootSelectors';
import VocabFITBView from '../../VocabFITBView';
import AvatarView from '../../../../common/avatar/avatarView';
import withAvatar from '../../../../common/avatar/withAvatar';
import { unmountScreen } from '../../../../common/screen/screenActions';
import { narrateReset, stopAudio } from '../../../../common/audio/audioActions';
import { narrateStimulus, resetSelectedIndex } from '../../../../common/questions/questionsActions';
import { onResponseSelect } from '../../../vocabActions';
import { fetchVocabFITBContent } from '../../vocabFITBActions';
import { narrateQuestionsScreen, onNextQuestionButtonClick } from './VocabFITBQuestionsActions';
import { getQuestionIndex } from '../../../../common/utils/urlParsers';
import { VOCAB_AUDIO_INSTRUCTIONS } from '../../../vocabConstants';
import { QUESTIONS } from '../../../../constants/assessmentItemType';
import { getAvatarPosition } from '../../../../common/alex/AlexUtils';

const mapStateToProps = (state, ownProps) => {
    const questionIndex = getQuestionIndex(ownProps.match.params);

    return {
        isDataFetched: selectors.getIsVocabFITBDataFetched(state),
        stimulus: selectors.getVocabFITBStimulusInfo(state, QUESTIONS, questionIndex - 1),
        possibleResponses: selectors.getVocabFITBPossibleResponses(
            state,
            QUESTIONS,
            questionIndex - 1,
        ),
        isScreenBlocked: selectors.getIsScreenBlocked(state),
        isStimulusPlaying: selectors.getIsStimulusPlaying(state),
        isNextButtonActive: selectors.getIsNextButtonActive(state),
        selectedResponse: selectors.getSelectedIndex(state),
        maxResponseLength: selectors.getMaxResponseLength(state, QUESTIONS, questionIndex - 1),
        questionIndex,
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    const questionIndex = getQuestionIndex(ownProps.match.params);

    return {
        fetchContent: () => {
            dispatch(fetchVocabFITBContent());
        },
        narrateScreen: stimulusAudio =>
            dispatch(narrateQuestionsScreen(questionIndex - 1, stimulusAudio)),
        playStimulus: stimulusAudio => dispatch(narrateStimulus(stimulusAudio)),
        selectResponse: response => dispatch(onResponseSelect(response)),
        onNext: response => dispatch(onNextQuestionButtonClick(response, questionIndex)),
        cleanup: () => {
            dispatch(stopAudio());
            dispatch(narrateReset());
            dispatch(resetSelectedIndex());
            dispatch(unmountScreen());
        },
    };
};

const avatarMapStateToProps = state => {
    const positionConfig = {
        alyxPosition: AvatarView.Position.TOP_HEADER_CENTER,
        defaultViewPosition: AvatarView.Position.LOWER_LEFT,
    };
    const position = getAvatarPosition(positionConfig);
    return {
        position,
        animateAlex: true,
        instructions:
            VOCAB_AUDIO_INSTRUCTIONS[selectors.getCurrentLanguage(state)]
                .vocabFITBInstructionReplay,
    };
};

const VocabFITBQuestionContainer = compose(
    connect(mapStateToProps, mapDispatchToProps),
    withAvatar(avatarMapStateToProps),
)(VocabFITBView);

export default VocabFITBQuestionContainer;
